import * as React from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, styled, alpha, Menu, MenuProps, MenuItem, SvgIconProps } from "@mui/material";

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: 0,
        // minWidth: 330,
        color: "rgb(55, 65, 81)",
        "& .MuiMenuItem-root": {
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
        "& .MuiButton-endIcon": {
            margin: 0,
            color: "transparent",
        }
    },
}));

const TextButton = styled(Button)(({ }) => ({
    textTransform: "none",
    padding: "6px 0 6px 0",
    fontSize: "14px",
    fontWeight: "bold",
    "&:hover": {
        backgroundColor: "transparent",
    },
}));

interface MenuComponentProps {
    label: React.ReactElement;
    menuItems: {
        label: string;
        onClick: () => void;
        icon: React.ReactNode
    }[];
}

export default function MenuComponent(props: MenuComponentProps) {
    const { label, menuItems } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <TextButton
                variant="text"
                disableElevation
                disableRipple
                disableFocusRipple
                aria-haspopup="true"
                onClick={handleClick}
                id="demo-customized-button"
                endIcon={<ArrowDropDownIcon />}
                aria-expanded={open ? "true" : undefined}
                aria-controls={open ? "demo-customized-menu" : undefined}
            >
                {label}
            </TextButton>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {menuItems.map((menuItem, index) => (
                    <MenuItem key={index} onClick={menuItem.onClick}>
                        <span style={{width: 50, display: "flex", gap: 5}}>
                            {menuItem.icon}
                            {menuItem.label.toUpperCase()}
                        </span>
                    </MenuItem>
                ))}
            </StyledMenu>
        </div>
    );
}
